import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer aussi l'enum Prisma `PlaceKind` dans schema.prisma
export enum PlaceKind {
  ESTABLISHMENT = 'ESTABLISHMENT',
  TRAVELING = 'TRAVELING',
  PHONE = 'PHONE',
  VIDEO = 'VIDEO',
}

export const PLACE_KIND_TRANSLATE_KEY = 'PLACE_KIND_';

export const PlaceKindTranslation = {
  'fr-FR': {
    [`${PLACE_KIND_TRANSLATE_KEY}${PlaceKind.ESTABLISHMENT}`]: 'En établissement',
    [`${PLACE_KIND_TRANSLATE_KEY}${PlaceKind.TRAVELING}`]: 'En déplacement',
    [`${PLACE_KIND_TRANSLATE_KEY}${PlaceKind.PHONE}`]: 'Par téléphone',
    [`${PLACE_KIND_TRANSLATE_KEY}${PlaceKind.VIDEO}`]: 'En visio',
  },
};

validateEnumTranslations(PlaceKind, PlaceKindTranslation, PLACE_KIND_TRANSLATE_KEY, true);
